import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full py-6 relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Edit", -1)
const _hoisted_3 = { class: "w-full h-full flex flex-col items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold" }, "Privacy Policy", -1)
const _hoisted_5 = ["innerHTML"]

import {ref, watch} from "vue";
import {PencilIcon} from "@heroicons/vue/24/outline";
import {useUserStore} from "@/stores/userStore";
import {storeToRefs} from "pinia";
import AddPolicyDialog from "@/components/admin/AddPolicyDialog.vue";
import {useHomeStore} from "@/stores/homeStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props) {

const userStore = useUserStore();
const {isAdmin} = storeToRefs(userStore);

const homeStore = useHomeStore();
const {policy} = storeToRefs(homeStore);

watch(policy, () => {
  privacyPolicy.value = policy.value.content
});

const privacyPolicy = ref(policy.value.content)

const getPrivacyPolicy = async () => {
  privacyPolicy.value = policy.value.content
}

getPrivacyPolicy();

const isEditPrivacyPolicyDialogOpen = ref(false)
const openEditPrivacyPolicyDialog = () => {
  isEditPrivacyPolicyDialogOpen.value = true
}

const closeEditPrivacyPolicyDialog = () => {
  isEditPrivacyPolicyDialogOpen.value = false
  homeStore.getPolicy(true)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isAdmin))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: openEditPrivacyPolicyDialog,
          class: "flex flex-row items-center text-white justify-center bg-brand-secondary px-6 py-2 rounded-xl absolute top-12 right-12"
        }, [
          _createVNode(_unref(PencilIcon), { class: "h-4 w-4" }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        class: "w-full mt-4 prose lg:prose-xl text-brand-text",
        innerHTML: privacyPolicy.value
      }, null, 8, _hoisted_5)
    ]),
    (isEditPrivacyPolicyDialogOpen.value)
      ? (_openBlock(), _createBlock(AddPolicyDialog, {
          key: 1,
          "on-close": closeEditPrivacyPolicyDialog,
          policy: privacyPolicy.value
        }, null, 8, ["policy"]))
      : _createCommentVNode("", true)
  ]))
}
}

})